<template>
  <div>
    <p class="mb-5">{{ 'employees.form.new-confirmation-description' | translate }}</p>
    <form-input-container
      title='Ingevoerde Gegevens'
      text='Controleer en bevestig de ingevoerde persoonsgegevens van de nieuwe werknemer.'>
      <div class='hf fl pt-3'>

        <table class='confirmation-table mr-5'>
          <tr>
            <td>{{ 'employee.name' | translate }}</td>
            <td>{{ newEmployee.getName() }}</td>
          </tr>
          <tr>
            <td>{{ 'employee.name-partner' | translate }}</td>
            <td>{{ newEmployee.getNamePartner() }}</td>
          </tr>
          <tr>
            <td>{{ 'employee.gender' | translate }}</td>
            <td>{{ newEmployee.gender | translate }}</td>
          </tr>
          <tr>
            <td>{{ 'employee.date-of-birth' | translate }}</td>
            <td>{{ formatDate(newEmployee.dateOfBirth) }}</td>
          </tr>
          <tr>
            <td>{{ 'employee.date-of-death' | translate }}</td>
            <td>{{ formatDate(newEmployee.dateOfDeath) }}</td>
          </tr>
        </table>

        <table class='confirmation-table'>
          <tr>
            <td>{{ 'employee.personel-number' | translate }}</td>
            <td>{{ relationship.employeeNumber }}</td>
          </tr>
          <tr>
            <td>{{ 'employee.employment-from-date' | translate }}</td>
            <td>{{ formatDate(relationship.fromDate) }}</td>
          </tr>
          <tr>
            <td>{{ 'employee.employment-until-date' | translate }}</td>
            <td>{{ formatDate(relationship.untilDate) }}</td>
          </tr>
          <tr>
            <td>{{ 'employee.characteristics-from-date' | translate }}</td>
            <td>{{ formatDate(detail.fromDate) }}</td>
          </tr>
          <tr>
            <td>{{ 'employee.kind-of-employment' | translate }}</td>
            <td>{{ 'nature-of-employment.'+detail.natureOfEmployement | translate }}</td>
          </tr>
          <tr>
            <td>{{ 'employee.gross-annual-salary' | translate }}</td>
            <td>{{ new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(detail.grossAnnualSalary.replace(',', '.')) }}</td>
          </tr>
          <tr>
            <td>{{ 'employee.profession-classification' | translate }}</td>
            <td>{{ 'profession-classification.'+detail.professionClassification | translate }}</td>
          </tr>
          <tr>
            <td>{{ 'employee.no-risk' | translate }}</td>
            <td>{{ detail.noRisk | translate }}</td>
          </tr>
        </table>
      </div>
    </form-input-container>

    <form-input-container
      title='Gekoppelde Polisgegevens'
      text='De werknemer wordt na akkoord als deelnemer geregistreerd op onderstaande polis(sen)'
      style='margin-top: -15px;'>
      <div style="display: block; height: 20px;" />
      <table class='participations' style='width: 100%;'>
        <new-employee-policy-participation v-for="p in newEmployee.allParticipations" :key="'policy-participation-' + p.policyNumber"
          :participation="p" />
      </table>
    </form-input-container>

    <div style="float: right" class='mt-4'>
      <Button primary  @click="this.handlePreviousClick" class="mr-3">{{ 'buttons.previous-step' | translate }}</Button>
      <Button positive @click="this.handleContinueClick" :disabled="isCreating">{{ isCreating ? 'employees.form.confirming-and-creating' : 'employees.create-new' | translate }}</Button>
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Helpers from '@/shared/helpers/functions';
import NewEmployee from '@/views/constants/employee-new';
import Employees from '@/resources/constants/employees';

import NewEmployeePolicyParticipation from '@/views/components/employee-new/NewEmployeePolicyParticipation.vue';

import Button from '@aevitae/aevitaeui/0_atoms/buttons/Button.vue';
import FormInputContainer from '@aevitae/aevitaeui/0_atoms/containers/FormInputContainer.vue';

export default {
  name: 'NewEmployeeConfirmation',
  components: {
    Button,
    FormInputContainer,
    NewEmployeePolicyParticipation
  },
  computed: {
    ...mapGetters({
      newEmployee: 'newEmployee',
      relationship: 'newEmployeeEmploymentRelationship',
      detail: 'newEmployeeEmploymentRelationshipDetail'
    }),

    isCreating () {
      return this.$store.getters.isCreateEmployeeLoading;
    }
  },
  methods: {
    formatDate: (date) => Helpers.Dates.formatDate(date),

    handleContinueClick () {
      // this.$store.dispatch(NewEmployee.Actions.Navigate.DO, NewEmployee.Views.Confirmation);
      // dispatch create
      this.$store.dispatch(Employees.Actions.Create.START, {
        employerId: this.$store.getters.selectedEmployer.id,
        employee: this.newEmployee,
        relationship: this.relationship,
        detail: this.detail
      });
    },
    handlePreviousClick () {
      this.$store.dispatch(NewEmployee.Actions.Navigate.DO, NewEmployee.Views.Employment);
    }
  }
};
</script>

<style lang='scss' scoped>
.participations {
  border-collapse: collapse;
  width: 100%;

}

</style>
